import { redirect } from "react-router";
import { api } from "./api";
import { tenantPath } from "./tenants";
import { toast } from "./toast";

/** The same words wherever an invitation is answered: these pages and an emailed link's. */
export const INVITATION_ACCEPTED = "Invitation accepted.";
export const INVITATION_DECLINED = "Invitation declined.";

/**
 * Answers an invitation from a page's action, for the two pages that show
 * them: the spaces page and the inbox. Accepting joins and opens the space;
 * declining consumes it and stays. Null for an intent that is not one of the
 * two, so the page's own action goes on to its other intents.
 *
 * Either answer says so in a toast: a declined invitation only leaves the
 * list, and an accepted one opens a space that says nothing of how you got
 * in.
 */
export async function answerInvitation(
  intent: string,
  form: FormData,
): Promise<Response | Record<string, never> | null> {
  const id = String(form.get("id") ?? "");
  switch (intent) {
    case "accept": {
      const joined = await api.invitations.accept({ id });
      toast(INVITATION_ACCEPTED);
      return redirect(tenantPath(joined));
    }
    case "decline":
      await api.invitations.decline({ id });
      toast(INVITATION_DECLINED);
      return {};
    default:
      return null;
  }
}
